export default __webpack_public_path__ + "static/media/image-ph-health-statistics-w.cefe59e0.webp";